import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { BaseService } from './base.service';
import { DataTablePage } from '../models/data-table-page.model';
import {
  EquipamentoInicioOperacao,
  EquipamentoInicioOperacaoFilter,
  EquipamentoInicioOperacaoLogFilter,
  EquipamentoLegacy,
  FiltrosInicioOperacao,
  LoteInicioOperacao,
} from '../models/equipamento-inicio-operacao.model';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class EquipmentOperationStartService extends BaseService {

  constructor(public override httpClient: HttpClient) {
    super(httpClient);
  }

  getList(page: DataTablePage, filters: EquipamentoInicioOperacaoFilter): Observable<any> {
    let url = `${this.getEndpoint('EQUIPMENT_OPERATION_START')}?page=${page.pageNumber}&size=${page.size}`;

    url += `&contractId=${filters.contratoId}`;
    if (filters.id != null) url += `&id=${filters.id}`;
    if (filters.equipamentoId?.length) url += `&equipamentoId=${filters.equipamentoId.join(',')}`;
    if (filters.loteId?.length) url += `&loteId=${filters.loteId.join(',')}`;
    if (filters.empresa?.length) url += `&empresa=${encodeURIComponent(filters.empresa.join(','))}`;
    if (filters.dataInicioOperacao) url += `&dataInicioOperacao=${encodeURIComponent(moment(filters.dataInicioOperacao).format('YYYY-MM-DD HH:mm:ss'))}`;
    if (filters.dataFimOperacao) url += `&dataFimOperacao=${encodeURIComponent(moment(filters.dataFimOperacao).format('YYYY-MM-DD HH:mm:ss'))}`;
    if (filters.dataInicioFaturamento) url += `&dataInicioFaturamento=${encodeURIComponent(moment(filters.dataInicioFaturamento).format('YYYY-MM-DD HH:mm:ss'))}`;
    if (filters.ativo != null) url += `&ativo=${filters.ativo}`;

    return this.getData(url).pipe(
      map((response) => {
        if (response) {
          page.totalElements = response.totalElements;
          page.totalPages = page.totalElements / page.size;
          return response;
        }
        return { content: [], totalElements: 0 };
      })
    );
  }

  getEquipamentos(contratoId: number): Observable<EquipamentoLegacy[]> {
    const url = this.getEndpoint('EQUIPMENT_OPERATION_LEGACY_EQUIPMENT').replace('{contractId}', String(contratoId));
    return this.getData(url).pipe(map((r) => r || []));
  }

  getLotes(): Observable<LoteInicioOperacao[]> {
    return this.getData(this.getEndpoint('EQUIPMENT_OPERATION_START_LOTES')).pipe(
      map((r) => r || [])
    );
  }

  getFilters(): Observable<FiltrosInicioOperacao> {
    return this.getData(this.getEndpoint('EQUIPMENT_OPERATION_START_FILTERS')).pipe(
      map((r) => r || { empresas: [] })
    );
  }

  create(payload: Omit<EquipamentoInicioOperacao, 'id' | 'createdAt' | 'updatedAt' | 'equipamentoNome'> & { userId: number }): Observable<any> {
    return this.postData(this.getEndpoint('EQUIPMENT_OPERATION_START'), payload);
  }

  update(id: number, payload: Omit<EquipamentoInicioOperacao, 'id' | 'createdAt' | 'updatedAt' | 'equipamentoNome'> & { userId: number }): Observable<any> {
    return this.putData(`${this.getEndpoint('EQUIPMENT_OPERATION_START')}/${id}`, payload);
  }

  delete(id: number, userId: number): Observable<any> {
    return this.deleteData(`${this.getEndpoint('EQUIPMENT_OPERATION_START')}/${id}?userId=${userId}`);
  }

  getHistory(page: DataTablePage, filters: EquipamentoInicioOperacaoLogFilter): Observable<any> {
    let url = `${this.getEndpoint('EQUIPMENT_OPERATION_START_HISTORY')}?page=${page.pageNumber}&size=${page.size}`;

    if (filters.equipamentoId?.length) url += `&equipamentoId=${filters.equipamentoId.join(',')}`;
    if (filters.acao?.length) url += `&acao=${filters.acao.join(',')}`;
    if (filters.userId?.length) url += `&userId=${filters.userId.join(',')}`;

    return this.getData(url).pipe(
      map((response) => {
        if (response) {
          page.totalElements = response.totalElements;
          page.totalPages = page.totalElements / page.size;
          return response;
        }
        return { content: [], totalElements: 0 };
      })
    );
  }

  getHistoryFilters(): Observable<any> {
    return this.getData(this.getEndpoint('EQUIPMENT_OPERATION_START_HISTORY_FILTERS'));
  }
}
